import settings from "../utils/settings";
import futureaxios from "@fpos/future-axios";

class emailService {
    constructor(errorCallBack) {
        this.sendEmail = this.sendEmail.bind(this);
        this.settings = settings;
        this._faxios = new futureaxios(`${settings.NotificationUrl}`, errorCallBack);
    }

    static create(errorCallBack) {
        return (() => {
            return new emailService(errorCallBack);
        })();
    }

    async sendEmail(email,subject, body, templateName,templateParams) {
        var emailMessage = {
            email: email,
            subject: subject,
            message: body,
            templateParms: {templateName: templateName, templateParams: templateParams}
        };
        var response = await this._faxios.post("", emailMessage);
        return response.axiosResponse.status === 204;
    }
}

export default emailService;